<template>
  <div class="bg-surface-default-low px-40 pb-40 pt-24">
    <RevContainer>
      <div class="flex flex-col gap-16" role="menu">
        <aside class="flex gap-8">
          <h2 class="flex-1">{{ i18n(translations.categories) }}</h2>
          <RevLink rel="no-follow" :to="universeURL">{{
            i18n(translations.see_all)
          }}</RevLink>
        </aside>
        <ul
          aria-label="universeTitle"
          class="grid grid-cols-5 gap-32"
          role="menu"
        >
          <li
            v-for="item in items"
            :key="item.id"
            class="max-w-256"
            role="none"
          >
            <RevLink
              class="body-2 flex flex-col gap-8"
              role="menuitem"
              :to="item.url"
              :underlined="false"
            >
              <RevIllustration
                v-if="item.image"
                :alt="item.title"
                class="rounded-lg"
                :height="960"
                :src="item.image"
                :width="1280"
              />
              <span class="text-action-default-low body-1-bold">
                {{ item.title }}
              </span>
            </RevLink>
          </li>
        </ul>
      </div>
    </RevContainer>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'

import translations from './NavMenu.translations'

const i18n = useI18n()

defineProps<{
  universeTitle: string
  universeURL: string
  items: Array<{
    id: number
    title: string
    image?: string
    url: string
  }>
}>()
</script>
